// export const REST_API_END_POINT = "https://wiseai-backend-api.skyniche.website/webservice/";
// export const REST_API = "https://wiseai-backend-api.skyniche.website/";
// export const REST_API_IMAGE = "https://wiseai-backend-api.skyniche.website";
export const REST_API_END_POINT = "https://website.signwisesolutions.com/backend/webservice/";
export const REST_API = "https://website.signwisesolutions.com/backend/";
export const REST_API_IMAGE = "https://website.signwisesolutions.com/backend";
// export const REST_API_END_POINT = "http://localhost:4000/webservice/";
// export const REST_API = "http://localhost:4000/";
// export const REST_API_IMAGE = "http://localhost:4000";
